export enum CheckoutOptionEnum {
  RENTAL_WALL_PICKUP = 'rental_wall_pickup',
  BRANCH_PICKUP = 'branch_pickup',
  DELIVERY = 'delivery',
}
